<!-- 圆形确认框 -->
<template>
  <van-dialog
    v-model="showDialog"
    :showConfirmButton="false"
    :close-on-click-overlay="isClickClose"
    @close="changeClose"
    class="generalConfirm"
  >
    <div class="TitleBox">
      <div class="deleteTitle">{{ title }}</div>
    </div>
    <div class="hintText">{{ content }}</div>
    <div class="deleteOperate">
      <button class="button deleteCancel" @click="closeDialog">取消</button>
      <button class="button deleteAffirm" @click="affirm">确认</button>
    </div>
  </van-dialog>
</template>
        <script>
export default {
  name: "SecondConfirm",
  components: {},
  model: {
    prop: "showDialog",
    event: "change",
  },
  props: {
    // 弹框的显示隐藏
    showDialog: {
      type: Boolean,
      default: false,
    },
    // 是否点击遮罩隐藏弹窗
    isClickClose: {
      type: Boolean,
      default: true,
    },
    // 标题
    title: {
      type: String,
      default: "提示",
    },
    // 标题
    content: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  methods: {
    affirm() {
      this.$emit("affirm", false);
    },
    closeDialog() {
      this.$emit("update:showDialog", false);
    },
    changeClose() {
      this.$emit("update:showDialog", false);
    },
  },
};
</script>
        <style lang="less" scoped>
/deep/.van-overlay {
  z-index: 9999 !important;
}
.generalConfirm {
  z-index: 9999 !important;
}
.button {
  border: none;
  background: none;
}
.TitleBox {
  position: relative;
  img {
    width: 16px;
    position: absolute;
    top: 50%;
    right: 20px;
    transform: translate(-50%, -50%);
  }
  .deleteTitle {
    font-size: 18px;
    font-weight: 400;
    color: #000;
    margin-top: 16px;
  }
}

.hintText {
  font-size: 15px;
  color: #666666;
  margin-top: 18px;
  padding: 0 24px;
  text-align: left;
}
.deleteOperate {
  margin: 22px auto 16px auto;
  .deleteCancel {
    width: 116px;
    height: 40px;
    background: #edeff3;
    border-radius: 20px;
    font-size: 16px;
    font-weight: 400;
    color: #9b9b9b;
    margin-right: 16px;
    line-height: 40px;
  }
  .deleteAffirm {
    width: 116px;
    height: 40px;
    background: #886df3;
    border-radius: 20px;
    font-size: 16px;
    font-weight: 400;
    color: #fff;
    line-height: 40px;
  }
  .gram {
    background: #aaacb5;
  }
}
</style>
        